"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Private = void 0;
/**
 * Implements proper private properties.
 *
 * @hidden
 */
var Private = /** @class */ (function () {
    function Private() {
        this.propMap = new WeakMap();
    }
    Private.prototype.get = function (obj) {
        return this.propMap.get(obj);
    };
    Private.prototype.set = function (obj, val) {
        this.propMap.set(obj, val);
    };
    return Private;
}());
exports.Private = Private;
